import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import on from 'dojo/on';
import template from './FileTileWidget.html?raw';
import FileTile from '../FileDashboard/FileTile';
import "../FileDashboard/FileTile";

import { FileDashboard } from "../FileDashboard/FileDashboardTypes";

class FileTileWidget extends compose(_WidgetBaseSP) {
    templateString: any = template;

    errorMessageNode: HTMLElement;

    private fileTile: FileDashboard.TileData = null;

    private tiles: Array<MdsLax<InstanceType<typeof FileTile>>>;

    tilesContainer: HTMLDivElement;
    dashBoardHeading: HTMLHeadingElement;

    applyDashboardWidgetParams(config) {
        this.loadReportDashboard(config.selectedReport)
    }


    loadReportDashboard(report?: string): void {
        this.StandbyStart(this.domNode);

        //this.setHeading(this.translations["ReportDashboard_Title"]);
        this.hideNode(this.domNode, false);

        let data = {
            selectedReport: report
        };

        let url = window.appRoot + "FileDashboard/GeFileTileWidget"
        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onLoadDashboardResponse),
            lang.hitch(this, this._onLoadDashboardError),
            false // sync
        );
    }

    _onLoadDashboardResponse(response: FileDashboard.TileData) {
        //console.log("_onLoadDashboardResponse", response);

        this.StandbyStop();

        this.setFileTile(response);

        this.hideNode(this.errorMessageNode);
    }

    _onLoadDashboardError(error: more.requestErrorMessage) {
        console.error("_onLoadDashboardError", error.Message);

        this.StandbyStop();

        alert("error loading report dashboard - maybe try again?\r\n" + error.Message);
        this.errorMessageNode.innerHTML = error.Message;
    }

    _onFileRequestedByManager(requestdata: FileDashboard.FileRequestData) {
        //console.debug("_onFileRequestedByManager", requestdata);
        
        //let data = requestdata.filterpanelData;

        let url = window.appRoot + "FileDashboard/RequestReport"
        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(requestdata)
            },
            lang.hitch(this, this._onRequestReportResponse, requestdata),
            lang.hitch(this, this._onRequestReportError, requestdata),
            false // sync
        );
    }

    _onRequestReportResponse(requestdata: FileDashboard.FileRequestData, response: FileFinder.FileDescriptor) {
        let data: FileDashboard.FileResponseData = { fileData: response, fileTileName: requestdata.fileTileName, targetRowIndex: requestdata.rowIndex, error: null };
        //this.fileTileWidget.loadReportDashboard(requestdata.fileTileName, requestdata["dateFrom"], requestdata["dateTo"]);
        //this._onClick_xAxis(this._lastOnClick_DataItem, {});
        this.setFileRequestResponse(data);

        //console.log("_onRequestReportResponse", requestdata, response);
    }

    _onRequestReportError(requestdata: FileDashboard.FileRequestData, error: more.requestErrorMessage) {
        let data: FileDashboard.FileResponseData = { fileData: null, fileTileName: requestdata.fileTileName, targetRowIndex: requestdata.rowIndex, error: error.Message };
        //this.manager.fileRequestResponse(data);
        alert(error.Message);

        this.setFileRequestResponse(data);
        //this._onClick_xAxis(this._lastOnClick_DataItem, {});
        //this.fileTileWidget.loadReportDashboard(requestdata.fileTileName, requestdata["dateFrom"], requestdata["dateTo"]);
    }


    setFileTile(fileTile: FileDashboard.TileData) {
        this.fileTile = fileTile;

        this.applySettings();
    }

    /*
    setHeading(text: string) {
        this.dashBoardHeading.innerHTML = text;
    }
    */

    private applySettings(): void {

        this.UiModder.domConstruct.empty(this.tilesContainer);
        this.tiles = [];

        /*
        if (!this.fileTile) {

            this.dashBoardHeading.innerHTML = "?settings?";

            return;
        }
        */

        let fileTile = this.fileTile;

        //this.setHeading(fileTile.title);


        let tile = new FileTile();
        tile.setData(fileTile);

        tile.placeAt(this.tilesContainer);

        on(tile, "requestFile", lang.hitch(this, this._onRequestNewFile));

        this.tiles.push(tile);
        this.emit("tilesCreated", this.tiles);
    }

    getTiles(): Array<MdsLax<InstanceType<typeof FileTile>>> {
        return this.tiles;
    }

    private _onRequestNewFile(data: FileDashboard.FileRequestData): void {
        this.emit("requestFile", data);
    }

    // Alias
    setFileRequestResponse(data: FileDashboard.FileResponseData): void {
        this.fileRequestResponse(data);
    }
    fileRequestResponse(data: FileDashboard.FileResponseData): void {
        let tile = this.getTileByName(data.fileTileName);

        if (tile) {
            tile.setFileRequestResponse(data);
        }
    }

    private getTileByName(name: string): MdsLax<InstanceType<typeof FileTile>> {
        for (let tile of this.tiles) {
            if (tile.internalName == name) {
                return tile;
            }
        }

        return null;
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        on(this, "requestFile", lang.hitch(this, this._onFileRequestedByManager));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FileTileWidget);
